import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export function useApprovalSearchParams({ statusDefault = 'PENDING' } = {}) {
  const [searchParams, setSearchParams] = useSearchParams()

  const updateParam = useCallback((key, value, resetPage = true) => {
    setSearchParams((previous) => {
      const next = new URLSearchParams(previous)
      const cleanValue = key === 'search' ? String(value || '') : String(value || '').trim()
      const isDefault = key === 'status'
        ? cleanValue === statusDefault
        : ['user_id', 'userFilter', 'department_id', 'project_id', 'task_id', 'search_field'].includes(key)
          ? cleanValue.toLowerCase() === 'all'
          : !cleanValue.trim()

      if (cleanValue && !isDefault) {
        next.set(key, cleanValue)
      } else {
        next.delete(key)
      }

      if (resetPage) next.delete('page')
      return next
    }, { replace: true })
  }, [setSearchParams, statusDefault])

  const updateParams = useCallback((values, resetPage = true) => {
    setSearchParams((previous) => {
      const next = new URLSearchParams(previous)
      Object.entries(values || {}).forEach(([key, value]) => {
        const cleanValue = key === 'search' ? String(value || '') : String(value || '').trim()
        const isDefault = key === 'status'
          ? cleanValue === statusDefault
          : ['user_id', 'userFilter', 'department_id', 'project_id', 'task_id', 'search_field'].includes(key)
            ? cleanValue.toLowerCase() === 'all'
            : !cleanValue.trim()
        if (cleanValue && !isDefault) next.set(key, cleanValue)
        else next.delete(key)
      })
      if (resetPage) next.delete('page')
      return next
    }, { replace: true })
  }, [setSearchParams, statusDefault])

  const setPageParam = useCallback((page) => {
    setSearchParams((previous) => {
      const next = new URLSearchParams(previous)
      if (page <= 1) next.delete('page')
      else next.set('page', String(page))
      return next
    }, { replace: true })
  }, [setSearchParams])

  return { searchParams, updateParam, updateParams, setPageParam }
}
